import fetch ,{postFrom} from "../utils/fetch";

'../utils/fetch'

//获取项目列表
export function list(params) {
  return fetch({
    method:'GET',
    url:'/project/list',
    params
  })
}


//区域检索条件列表
export function selectCondition() {
  return fetch({
    method:'GET',
    url:'/project/selectCondition',
  })
}

//添加项目基本信息
export function saveBaseInfo(params) {
  return fetch({
    method:'POST',
    url:'/project/saveBaseInfo',
    data:params
  })
}

//修改项目基本信息
export function updateBaseInfo(params) {
  return fetch({
    method:'POST',
    url:'/project/updateBaseInfo',
    data:params
  })
}

//项目添加条件
export function addCondition() {
  return fetch({
    method:'POST',
    url:'/project/addCondition',
  })
}

//build添加条件
export function buildCondition() {
  return fetch({
    method:'POST',
    url:'/housebuilding/toAdd',
  })
}

//添加楼栋接口
export function saveBuildingInfo(params) {
  return fetch({
    method:'POST',
    url:'/housebuilding/saveBuildingInfo',
    data:params
  })
}
//跳转到楼栋编辑页面
export function toEdit(params) {
  return fetch({
    method:'POST',
    url:'/housebuilding/toEdit',
    params
  })
}

//校验删除楼栋
export function validDeleteContidion(params) {
  return fetch({
    method:'POST',
    url:'/housebuilding/validDeleteContidion',
    params
  })
}

//添加房型
export function housetypeAdd(params) {
  return fetch({
    method:'POST',
    url:'/housetype/add',
    data:params
  })
}
//修改房型
export function housetypeUpdate(params) {
  return fetch({
    method:'POST',
    url:'/housetype/edit',
    data:params
  })
}

//房型筛选条件
export function forCondition(params) {
  return fetch({
    method:'GET',
    url:'/housetype/forCondition',
    params
  })
}

// 户型枚举下拉框数据
export function getSelectHouseTypes() {
  return fetch({
    method: 'GET',
    url: '/housetype/houseTypes'
  })
}


export function housetypelist(params) {
  return fetch({
    method:'GET',
    url:'/housetype/list',
    params
  })
}

export function housetypeToEdit(params) {
  return fetch({
    method:'POST',
    url:'/housetype/toEdit',
    params
  })
}

export function housetypeVaild(params) {
  return fetch({
    method:'POST',
    url:'/housetype/vaildDelete',
    params
  })
}

export function getBaseInfoByProjectId(params) {
  return fetch({
    method:'GET',
    url:'/project/getBaseInfoByProjectId',
    params
  })
}


export function buildingUpdate(params) {
  return fetch({
    method:'POST',
    url:'/housebuilding/edit',
    data:params
  })
}

//获取项目资料类型
export function getProjectInfoType() {
  return fetch({
    method:'POST',
    url:'/projectInfo/getProjectInfoType',
  })
}

//编辑项目资料
export function projectInfoEdit(params) {
  return fetch({
    method:'POST',
    url:'/projectInfo/edit',
    data:params
  })
}

//编辑项目资料
export function getProjectInfoByProjectIdAndType(params) {
  return fetch({
    method:'GET',
    url:'/projectInfo/getProjectInfoByProjectIdAndType',
    params
  })
}
//


export function housebuildinglist(params) {
  return fetch({
    method:'GET',
    url:'/housebuilding/list',
    params
  })
}

export function ownerChangeRecordlist(params) {
  return fetch({
    method:'GET',
    url:'/project/ownerChangeRecord/list',
    params
  })
}

export function projectregion(params) {
  return fetch({
    method:'GET',
    url:'/project/projectRegion',
    params
  })

}

export function removeConfigImg(params) {
  return fetch({
    method:'GET',
    url:'/label/removeConfigImg',
    params
  })

}
export function projectdelete(params) {
  return fetch({
    method:'POST',
    url:'/project/delete',
    params

  })
}
export function getAllData(params) {
  return fetch({
    method:'GET',
    url:'/projectSearch/projectDetail',
    params
  })

}

//品牌机构联动
export function getOrganInfoAndBrand(organId) {
  return fetch({
    method:'GET',
    url:'/project/getOrganInfoAndBrand',
    params:{
      organId
    }
  })
}
